import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=18a037d8"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports